import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "information",
  "use": "information-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"information\">\n  <path d=\"M24 4a20 20 0 1 0 20 20A20 20 0 0 0 24 4m2.138 30.292h-4.25V19.347h4.25Zm-.323-17.144a2.904 2.904 0 0 1-3.575 0 2.07 2.07 0 0 1-.732-1.67 2.07 2.07 0 0 1 .732-1.67 2.905 2.905 0 0 1 3.575 0 2.07 2.07 0 0 1 .733 1.67 2.07 2.07 0 0 1-.733 1.67\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol